<mat-form-field appearance="fill">
  <mat-label>{{ props.label }}</mat-label>

  <input
    matInput
    [id]="id"
    [type]="'text'"
    [readonly]="props.readonly"
    [required]="required"
    [errorStateMatcher]="errorStateMatcher"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [tabIndex]="props.tabindex"
    [placeholder]="props.placeholder ?? ''"
    [ngxMatTimepicker]="pickerA"
  />
  <mat-icon matSuffix (click)="props.readonly || pickerA.open()"
    >schedule</mat-icon
  >
  <mat-error>
    <formly-validation-message [field]="field"></formly-validation-message>
  </mat-error>
</mat-form-field>

<ngx-mat-timepicker [format]="24" #pickerA></ngx-mat-timepicker>
